import { com, kotlin } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import AuthenticationContext from '../../authorization/AuthenticationContext'
import Entity = com.eidu.sharedlib.entity.Entity
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import KtList = kotlin.collections.KtList
import PaginatedResponseWithRelated = com.eidu.api.pagination.PaginatedResponseWithRelated
import entityPaginatedResponseWithRelatedFromJsonString = com.eidu.sharedlib.entity.api.entities.entityPaginatedResponseWithRelatedFromJsonString
import KeysetPaginatedResponseWithRelated = com.eidu.api.pagination.KeysetPaginatedResponseWithRelated
import IndexedPaginatedResponseWithRelated = com.eidu.api.pagination.IndexedPaginatedResponseWithRelated

type GetEntitiesOfTypeParameters = {
  id: EntityTypeId
  withRelatedEntities?: boolean
  pageIndex?: number
  pageSize: number
  cursor?: string
  query?: string
  authContext: AuthenticationContext
  signal?: AbortSignal
}

const getEntitiesOfType = ({
  id,
  withRelatedEntities,
  pageIndex,
  pageSize,
  cursor,
  query,
  authContext,
  signal,
}: GetEntitiesOfTypeParameters): Promise<PaginatedResponseWithRelated<Entity>> => {
  if (pageIndex !== undefined && cursor === undefined) {
    requireValidPaginationParameters(pageIndex, pageSize)
  }

  const related = withRelatedEntities ? 'true' : 'false'
  const params = new URLSearchParams({
    related,
    pageSize: pageSize.toString(),
  })

  if (cursor !== undefined) {
    params.append('cursor', cursor || '')
  } else if (pageIndex !== undefined) {
    params.append('pageIndex', pageIndex.toString())
  }

  if (query) {
    params.append('query', query)
  }

  return fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}/entities?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${authContext.accessToken}`,
        Accept: 'application/json',
      },
      signal,
    }
  ).then(async (response): Promise<PaginatedResponseWithRelated<Entity>> => {
    switch (response.status) {
      case 200: {
        const responseText = await response.text()
        return entityPaginatedResponseWithRelatedFromJsonString(responseText)
      }
      case 401:
      case 403:
        if (cursor !== undefined || (pageIndex === undefined && query)) {
          return new KeysetPaginatedResponseWithRelated(KtList.fromJsArray([]), KtList.fromJsArray([]), null)
        } else {
          return new IndexedPaginatedResponseWithRelated(KtList.fromJsArray([]), KtList.fromJsArray([]), 0)
        }
      default:
        throw Error(`Unexpected response code ${response.status} from getEntitiesOfType endpoint`)
    }
  })
}

export default getEntitiesOfType
